import classNames from "classnames"
import { ArrowRight, Lock } from "components/Icons"
import style from "components/Resource.module.scss"
import Img from "gatsby-image"
import camelCase from "lodash/camelCase"
import React from "react"

const Resource = ({
  title,
  subTitle,
  url,
  icon,
  isVideo,
  isRestricted,
  theme
}) => {
  const className = classNames(
    style.root,
    style[`root___theme_${camelCase(theme)}`]
  )

  return (
    <a href={url} className={className} target="_blank" rel="noreferrer">
      <div className={style.content}>
        <div className={style.image}>
          {!!icon && (
            <Img
              placeholderStyle={{ visibility: "hidden" }}
              fluid={icon.fluid}
            />
          )}
        </div>

        <div className={style.text}>
          <div className={style.title}>{title}</div>
          {!!subTitle && <div className={style.subTitle}>{subTitle}</div>}
        </div>

        <div className={style.icon}>
          {isRestricted ? <Lock /> : <ArrowRight strokeWidth={1.25} />}
        </div>
      </div>
    </a>
  )
}

Resource.defaultProps = {
  backgroundColor: "none"
}

export default Resource
